import {MarginQuizQuestionController} from "./MarginQuizQuestionController";
import {BULL_CALL, SHORT_CALL_EXERCISED} from "../MarginQuizQuestions";

export const ShortCallExercised = "tfShortCallExercisedQuestion";

export function shortCallExercised() {
    return {
        templateUrl: "app/quiz/margin/questions/ShortCallExercised.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: ShortCallExercisedController
    };
}

export class ShortCallExercisedController extends MarginQuizQuestionController {
    public config = SHORT_CALL_EXERCISED;
}
